import { Box } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { TextDisplayCell } from "../../../common/components/DataGrid";
import { generateHiddenCell } from "../../helpers/CellGenerators";

export const HiddenCell = ({ row }) => {
  const isHidden = generateHiddenCell(row);

  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
      {isHidden ? (
        <VisibilityOff
          fontSize='small'
          titleAccess='Hidden'
          aria-label='Hidden'
          sx={{ color: "text.secondary" }}
        />
      ) : (
        <Visibility
          fontSize='small'
          titleAccess='Visible'
          aria-label='Visible'
          sx={{ color: "text.secondary" }}
        />
      )}
      <TextDisplayCell value={isHidden ? "Yes" : "No"} />
    </Box>
  );
};
